// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"76e90cc7","317":"f0698d88","601":"306800b9"}[chunkId] + ".chunk.js";
};